import { render, staticRenderFns } from "./questionnaireStatistics.vue?vue&type=template&id=8225fc96&scoped=true&"
import script from "./questionnaireStatistics.vue?vue&type=script&lang=js&"
export * from "./questionnaireStatistics.vue?vue&type=script&lang=js&"
import style0 from "./questionnaireStatistics.vue?vue&type=style&index=0&id=8225fc96&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8225fc96",
  null
  
)

component.options.__file = "questionnaireStatistics.vue"
export default component.exports